import { useEffect, useState, useMemo } from "react";

import { Button, Box, Icon, Paper, TextField, useTheme, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TableFooter, LinearProgress, Autocomplete, CircularProgress, FormGroup, FormControlLabel, Checkbox, Typography, Pagination, Tooltip } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom"

import { ISetor, SetorService } from "../../shared/services/api/setor/SetorService";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { Environment } from "../../shared/environment";
import { AlertSnackBar, AutoCompleteDeUnidade } from "../../shared/components";
import { IPaginacao } from "../../shared/services/api/axios-config";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";
import { margin } from "@mui/system";

export const ListagemDeSetor: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [isLoading, setIsLoading] = useState(false);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [rows, setRows] = useState<ISetor[]>([]);
  const [idUnidade, setIdUnidade] = useState<number | undefined | null>(undefined);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  useEffect(() => {
    setIdUnidade(Number(localStorage.getItem("idUnidade")))
  }, []);
  
  useEffect(() => {
    handleNewSearch(false);
  }, [idUnidade]);

  useEffect(() => {
    handleNewSearch(true);
  }, [pagina]);

  const handleNewSearch = (newPage: boolean) => {
    setIsLoading(true);

    if (idUnidade === undefined || idUnidade === null || idUnidade == 0) {
      setRows([]);
      setIsLoading(false);
      resetPaginacao();
    } else {
      if (newPage) {
        SetorService.getByIdUnidade(idUnidade, pagina, true).then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.setor);
            setPaginacao(result.paginacao);

          }
        });
      } else {
        setSearchParams({ pagina: "1" }, { replace: true })
        setRows([]);
        resetPaginacao();
        SetorService.getByIdUnidade(idUnidade, 1, true).then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.setor);
            setPaginacao(result.paginacao);

          }
        });
      }
    }


  };

  const handleDelete = () => {
    setAbrir(false);
    setIsLoading(true);
    SetorService.toggleEstadoById(idToDelete)
      .then(result => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlert({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        } else {
          setRows(oldRows => {
            return [
              ...oldRows.filter(oldRow => oldRow.idSetor !== idToDelete),
            ]
          });
          setAlert({ tipoAlert: "sucesso", mensagem: "Setor desativado com sucesso" });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        }
      });

  }

  const [abrir, setAbrir] = useState(false);
  const [idToDelete, setidToDelete] = useState<number>(0);

  const handleClickDelete = (idSetor: number) => {
    setAbrir(true);
    setidToDelete(idSetor);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  return (
    <LayoutBaseDePagina
      titulo="Listagem de setores"
      barraDeFerramentas={null}
    >
      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      <DialogConfirm
        AoConfirmar={handleDelete}
        titulo={"Dejesa realmente desativar o setor?"}
        texto={"Ao confirmar, o setor e tudo que está contido nele será desativado, para defazer a ação será necessário reativar-lo na listagem de setores desativado."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      <Box
        component={Paper}
        height={theme.spacing(5)}
        marginX={1}
        padding={1}
        paddingX={2}
        display="flex"
        gap={1}
        alignItems="center"
      >
        <AutoCompleteDeUnidade selectedIdUnidade={selectedIdUnidade => setIdUnidade(selectedIdUnidade)} />

        <Box flex={1} display="flex" justifyContent="end">
          <Button
            color="primary"
            disableElevation
            variant="contained"
            endIcon={<Icon>do_disturb</Icon>}
            onClick={() => navigate('/setor/desativado')}
          >
            Desativados
          </Button>
          <Box width={5}></Box>

          {(idUnidade === 0 || idUnidade === null || idUnidade === undefined)
            || (localStorage.getItem("cnpj") === "" || localStorage.getItem("cnpj") === null || localStorage.getItem("cnpj") === undefined) ?
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              disabled
            >
              Novo
            </Button>
            :
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              onClick={() => navigate('/setor/detalhe/novo')}
            >
              Novo
            </Button>
          }

        </Box>
      </Box>

      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell align="center"> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idSetor}>
                <TableCell> {row.nomeSetor} </TableCell>
                <TableCell align="center">

                  <IconButton size="small" onClick={() => navigate(`/setor/detalhe/${row.idSetor}`)}>
                    <Tooltip arrow title="Editar setor">
                      <Icon> edit </Icon>
                    </Tooltip>
                  </IconButton>

                  <IconButton size="small" onClick={() => handleClickDelete(row.idSetor)}>
                    <Tooltip arrow title="Desativar setor">
                      <Icon> delete </Icon>
                    </Tooltip>
                  </IconButton>

                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao?.totalCount === 0 && !isLoading && (idUnidade !== undefined && idUnidade !== null && idUnidade !== 0) && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}
          {idUnidade === undefined || idUnidade === null || idUnidade == 0 && !isLoading && (
            <caption> Selecione uma unidade e uma área para pesquisar </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={2}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(paginacao?.totalPages > 1 && !isLoading) && (
              <TableRow>

                <TableCell colSpan={2} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>

              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>

    </LayoutBaseDePagina >
  )
}
